import * as actions from '@/store/actions';
import * as getters from '@/store/getters';
import mutations from '@/store/mutations';
import { createStore } from 'vuex';
import { environmentVariable, resolveEnvironmentVariable } from '@/lib/env';
import { getDefaultState } from '@/store/helper';

const strict = (() => {
  const vuexStrictMode = resolveEnvironmentVariable(environmentVariable.VUEX_STRICT_MODE) ?? false;
  return vuexStrictMode === 'true' || vuexStrictMode === true;
})();

const state = getDefaultState();

export default function useStoreInit(modules) {
  const config = {
    state,
    actions,
    mutations,
    getters,
    modules,
  };

  /* eslint-disable new-cap */
  return new createStore({
    ...config,
    strict,
  });
  /* eslint-enable new-cap */
}
